module.exports = __webpack_public_path__ + "img/phoneHead.1d9141c1.png";